import "./scss/quanzi.pc.scss";

import $ from "jquery";
import controllers from "./controllers";
import tool from "tool";
import avalon from "avalon";
import dialog from "dialog";
import ajax from "ajax";
import pjax from "pjax";
import "lazyload";
import { webp } from "aiyuke-front-lib";

avalon.config({ interpolate: ["[[", "]]"] });

tool.init($);

var gHiddenValues = tool.getHiddenValues("#js-hiddens");

$(document).pjax("a[data-pjax]", "#pjax-container");

if ($.pjax.defaults) {
    $.pjax.defaults.timeout = 50000;
    $.pjax.defaults.except = [gHiddenValues.mall];
}

$(window).on("lazyload.image.appear", function(event, $img, settings) {
    let origin = $img.attr("data-" + settings.data_attribute);
    origin = webp.replaceSrcH5(origin);
    $img.data("data-webp-" + settings.data_attribute, origin);
});

var clearProgress;
$(document)
    .on("pjax:send", function() {
        // dialog.mask.show();
        clearTimeout(clearProgress);
        dialog.progress.width(0);
        dialog.progress.show(0);
        setTimeout(function() {
            dialog.progress.show(70);
        }, 300);
    })
    .on("pjax:beforeReplace", function(event, doms) {
        // $.each(doms, function(i, dom) {
        //	var $dom = $(dom);
        //	if ($dom.hasClass("overlay") || $dom.hasClass("mask")) {
        //		$dom.hide();
        //	}
        // });
        // dialog.mask.show();
        dialog.progress.width(90);
        // dialog.progress.show(100);
    })
    .on("pjax:end", function(xhr, options) {
        // 判断是否未登录
        if (typeof options === "object" && options.status == 302) {
            return;
        }
        dialog.progress.width(100);
        dialog.progress.fadeOut();
        clearProgress = setTimeout(function() {
            dialog.progress.hide();
            dialog.progress.fadeIn();
            dialog.progress.width(0);
            dialog.clear();
        }, 1000);
        $("#footer-top, #footer-bar").show();
        scan();
    })
    .on("pjax:error", function(err) {
        // dialog.mask.hide();
        // dialog.progress.hide();
        // dialog.progress.width(0);
    })
    .on("pjax:timeout", function() {
        // dialog.mask.hide();
        dialog.progress.hide();
        dialog.progress.width(0);
    });

var scan = (function() {
    var lastController = null, // 上一个控制器
        pjaxContainer = $("#pjax-container"); // pjax的容器

    return function() {
        var avalonContainer, controllerId, controller, hiddenValues;

        avalonContainer = pjaxContainer.find("div[ms-controller]");
        if (avalonContainer.length <= 0) {
            avalonContainer = pjaxContainer.find("div[avalonctrl]");
        }

        controllerId =
            avalonContainer.attr("ms-controller") ||
            avalonContainer.attr("avalonctrl");

        controller = controllers[controllerId]; // avalon控制器

        // tool.fixTitle(hiddenValues);

        if (controller) {
            lastController && lastController.clear();
            controller.init();

            // 由于avalon2当中，avalon.scan的方法里判断了$element是否存在如果$element存在则不会进行scan，
            // 导致pjax返回上一个页面后avalon不渲染，因此加上以下一行代码将$element置为空
            // 由于增加该行代码 在谷歌浏览器中使用Ctrl+F5强制刷新会导致for循环整体多循环N次 因此增加了判断
            if (lastController) {
                delete avalon.vmodels[controllerId].$element;
                document.title =
                    (window.server.Base && window.server.Base.title) ||
                    document.title;
            }

            avalon.scan(avalonContainer.get(0));
            lastController = controller;
        }
    };
})();

$(function() {
    scan();
    setTimeout(function() {
        $("#header .pop").css("top", "100%");
    }, 300);
    // $('.mask').fadeOut();
    $(".overlay").fadeOut();
});
// 搜索
var search = function() {
    var text = $(".search input").val();
    if (text == "") {
        return dialog.alert("搜索内容不能为空！");
    }
    ajax.pjax(decodeURIComponent(window.server.searchUrl + text));
    console.log(1);
};
$("body")
    .on("keydown", "#search-input", function(e) {
        if (e.keyCode == 13) {
            search();
        }
    })
    .on("click", "#search", function() {
        search();
    });
